import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import { Container, Row } from "../admin/styles";

// core components
import AdminNavbar from "../../components/Navbar/index";
import Footer from "../../components/Footer/index";
import Sidebar from "../../components/Sidebar/index";
import routes from "../../routes/clients.routes";
import mainRouteInterface from "../../routes/interfaces/mainRouteInterface"
// import { Container } from "./styles";

const Clients = () => {
  const getRoutes = (routes: Array<mainRouteInterface>) => {
    return routes.map((prop, key) => {
        return (
          <Route
            path={`/admin${prop.layout}${prop.path}`}
            component={prop.component}
            key={key}
          />
        );
    });
  };

  return (
    <>
      <Row>
        <Sidebar />
        <Container>
          <AdminNavbar />
          <Switch>
            {getRoutes(routes)}
            <Redirect from="*" to="/admin/clients/sellers" />
          </Switch>
          <Footer />

        </Container>
      </Row>
    </>
  );;
}

export default Clients;